import { App } from 'antd';
import { useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { Palette } from 'lucide-react';

import { PageHeader, Tile, TileBody, TileHeader } from '../../../components/shared';
import { Badge, Button } from '../../../components/ui';
import { Dialog } from '../../../components/ui/Dialog';
import { useTheme } from '../../../components/ThemeProvider';
import { usePhamVi } from '../../../hooks/usePhamVi';
import { useT } from '../../../i18n';
import { TUY_CHINH_MAC_DINH } from '../../../styles/tuy-chinh';
import { TabToChuc } from '../../ho-so-to-chuc/components/TabToChuc';
import { useQuanTriToChuc } from '../../ho-so-to-chuc/hooks/useQuanTriToChuc';
import { CHE_DO_NEN_MAC_DINH } from '../constants';
import { ThietLapCaNhan } from '../components/ThietLapCaNhan';
import { XemTruoc } from '../components/XemTruoc';

/** Màn "Giao diện" (ADR-UI-0018): thiết lập cá nhân, nhận diện tổ chức và xem trước. */
export function GiaoDienView() {
  const { t } = useT();
  const { message } = App.useApp();
  const { cheDo, setCheDo, tuyChinh, setTuyChinh } = useTheme();

  const coQuyenSuaToChuc = useQuanTriToChuc();
  const congTenant = usePhamVi() === 'tenant';
  const hienToChuc = coQuyenSuaToChuc && congTenant;

  const [chuaLuu, setChuaLuu] = useState(false);
  const chan = useBlocker(chuaLuu);

  const laMacDinh =
    cheDo === CHE_DO_NEN_MAC_DINH &&
    tuyChinh.mauNhan === TUY_CHINH_MAC_DINH.mauNhan &&
    tuyChinh.boGoc === TUY_CHINH_MAC_DINH.boGoc;

  const datLaiTatCa = () => {
    setCheDo(CHE_DO_NEN_MAC_DINH);
    setTuyChinh(TUY_CHINH_MAC_DINH);
    void message.success(t('tuyChinh.daDatLai'));
  };

  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        <PageHeader
          titleIcon={<Palette size={18} className="text-primary-600" />}
          title={t('tuyChinh.tieuDe')}
          actions={
            <Button variant="outline" size="sm" disabled={laMacDinh} onClick={datLaiTatCa}>
              {t('tuyChinh.datLaiTatCa')}
            </Button>
          }
        />

        <div className="grid grid-cols-12 gap-4">
          <ThietLapCaNhan />
          <XemTruoc />

          {hienToChuc && (
            <Tile span="xl:col-span-8">
              <TileHeader
                tone="primary"
                title={t('hoSoToChuc.tieuDe')}
                action={<Badge variant="neutral">{t('hoSoToChuc.apDungToanTo')}</Badge>}
              />
              <TileBody>
                <TabToChuc onDirty={setChuaLuu} />
              </TileBody>
            </Tile>
          )}
        </div>
      </div>

      <Dialog
        open={chan.state === 'blocked'}
        onClose={() => chan.reset?.()}
        title={t('hoSoToChuc.chuaLuu.tieuDe')}
        footer={
          <div className="flex justify-end gap-2">
            <Button variant="secondary" onClick={() => chan.reset?.()}>
              {t('chung.huy')}
            </Button>
            <Button variant="destructive" onClick={() => chan.proceed?.()}>
              {t('hoSoToChuc.chuaLuu.boThayDoi')}
            </Button>
          </div>
        }
      >
        <p className="text-sm text-content-secondary">{t('hoSoToChuc.chuaLuu.than')}</p>
      </Dialog>
    </div>
  );
}
